/**
 * Default value for alternative "other" in single and multiple select type questions
 */
export const other_option = "-1";
/**
 * Default value for alternative "not apply" in selection type questions
 */
export const no_apply_option = "-2"; 